import { combineReducers } from '@reduxjs/toolkit';
import { reducer as chatReducer } from 'src/slices/chat';
// import { reducer as formReducer } from 'redux-form';
import { reducer as notificationReducer } from 'src/slices/notification';
import { reducer as automationRulesReducer } from 'src/slices/automation-rules';
import { reducer as rewardsReducer } from 'src/slices/rewards';

const rootReducer = combineReducers({
  chat: chatReducer,
  // form: formReducer,
  notifications: notificationReducer,
  automationRules: automationRulesReducer,
  rewards: rewardsReducer,
});

export default rootReducer;
